// extracted by mini-css-extract-plugin
module.exports = {"fondo":"TarjetasEducativas__fondo__2rBFD","border":"TarjetasEducativas__border__3zwsk"};